var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anomaly-colorbar"},[_c('div',{staticClass:"ticks"},_vm._l((_vm.ticks),function(t){return _c('span',{key:t},[_vm._v(_vm._s(t))])}),0),_c('div',{staticClass:"bar"}),_c('div',{staticClass:"labels"},[_c('span',[_vm._v(_vm._s(_vm.t("underperforming")))]),_c('span',[_vm._v(_vm._s(_vm.t("outperforming")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }